export type MovieType = "movie" | "drama";

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  cover: string;
  still: string;
  synopsis: string;
  tags: string[];
  popularity: number;
  releaseDate: string;
}

export const TYPE_LABEL: Record<MovieType, string> = {
  movie: "电影",
  drama: "电视剧",
};